export function getAppEnvironment() {
  if (window.cordova) return 'cordova';
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return 'pwa';
  return 'web';
}